import { createContext } from 'react';
import type { CrmTaskInputDTO } from '../../server/dto/crm-task-input-dto.ts';

/** A task staged in the log interaction form — newly queued, or an edit of an existing one. */
export type TaskListItem = {
    key: string;
    values: CrmTaskInputDTO;
    assigneeName?: string;
    pending: boolean;
    onChange: (values: CrmTaskInputDTO) => void;
};

export type LogInteractionTasksContextValue = {
    items: TaskListItem[];
    addTasks: (tasks: CrmTaskInputDTO[]) => void;
};

export const LogInteractionTasksContext = createContext<LogInteractionTasksContextValue | undefined>(
    undefined,
);
